/* eslint-disable */

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import hu_HU from './languages/hu_HU.json';
import en_US from './languages/en_US.json';
import dkt_HU from './languages/dkt_HU';

Vue.use(VueI18n);

const locale = 'en_US';

const messages = {
  hu_HU,
  en_US,
  dkt_HU
};

const i18n = new VueI18n({
  locale,
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/lang.js